export const forBusiness_realEstate_enhancement = [
	{
		icon: '⭐️',
		title: 'enhancementData_title1',
		subtitle: 'enhancementData_subtitle1',
	},
	{
		icon: '⏳',
		title: 'enhancementData_title2',
		subtitle: 'enhancementData_subtitle2',
	},
	{
		icon: '👠',
		title: 'enhancementData_title3',
		subtitle: 'enhancementData_subtitle3',
	},
	{
		icon: '🚀',
		title: 'enhancementData_title4',
		subtitle: 'enhancementData_subtitle4',
	},
	{
		icon: '✌️',
		title: 'enhancementData_title5',
		subtitle: 'enhancementData_subtitle5',
	},
];
